import Component from '@glimmer/component';

export default class MwHomeRegistrationPageComponent extends Component {}
